import { createContext , useContext, useState } from "react";
import { UserContext } from "./UserContext.js";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";




export let BranchContext = createContext();


export default function BranchContextProvider(props){
   // const navigate = useNavigate() ;
   const {userToken } = useContext(UserContext) ;

   
   const [branches , setBranches] = useState([]) ;
   const [branchData , setBranchData] = useState({}) ;
   const [filter , setFilter] = useState("") ;
   const [countItem , setCountItem] = useState(10) ;

   const [currentPage , setCurrentPage] = useState(0) ;
   const [numberOfPages , setNumberOfPages] = useState(0) ;
   const [limit , setLimit] = useState(0) ;
   const [branchCount , setBranchCount] = useState(0) ;
   const[branch , setBranch] = useState({}) ;
   const [pageCount ,  setPageCount] = useState(0) ;

   const header = {
      token:`${process.env.REACT_APP_BEARER_TOKEN} ${userToken || localStorage.getItem("token")}`
   }

   async function getSpecificBranch(id){
      await axios.get(`${process.env.REACT_APP_BASE_URL}/api/v1/branch/${id}`  ,  {headers:header} )
      .then(({data})=>{
         if(data.message === "success"){
            setBranch(data.branch)
         }
      })
      .catch((error)=>{
         toast.error(error.response.data.message)
      })
   }


   async function deleteBranch(id){
      Swal.fire({
         title: "Are you sure?",
         text: "You won't be able to revert this!",
         icon: "warning",
         showCancelButton: true,
         confirmButtonColor: "#3085d6",
         cancelButtonColor: "#d33",
         confirmButtonText: "Yes, delete it!"
      }).then(async(result) => {
         if (result.isConfirmed) {
            await axios.delete(`${process.env.REACT_APP_BASE_URL}/api/v1/branch/${id}`  ,  {headers:header} )
            .then(({data})=>{
               if(data.message === "success"){
                  Swal.fire({
                     title: "Successfully Deleted Branch",
                     text: "Your file has been deleted.",
                     icon: "success"
                  });
               }
            })
            .catch((error)=>{
               Swal.fire({
                  title:error.response.data.message  ,
                  text: "Please Try Again" ,   
                  icon: "error"
                  });
            })
         }
      });
   }


   async function getTypeBranch (item){
      setFilter(item)
      await axios.get(`${process.env.REACT_APP_BASE_URL}/api/v1/branch?${item}`  ,  {headers:header} )
      .then(({data})=>{
         if(data.message === "success"){
            setBranches(data.branches) ;
            showCurrentPage(data) ;
            setPageCount (data.metadata.numberOfPages) ;
         }
      })
      .catch((error)=>{
         toast.error(error.response.data.message)
      })
   }

   async function getData (){
      await axios.get(`${process.env.REACT_APP_BASE_URL}/api/v1/branch/getBranchCount`  ,  {headers:header} )
      .then(({data})=>{
         if(data.message === "success"){
            setBranchData(data) ;
         }
      })
      .catch((error)=>{
         toast.error(error.response.data.message)
      })
   }



   const fetchData = async(currentPage)=>{
      await axios.get(`${process.env.REACT_APP_BASE_URL}/api/v1/branch?${filter}&page=${currentPage}`  ,  {headers:header})
      .then(({data})=>{
         setBranches(data.branches);
         showCurrentPage(data) ;
         setPageCount (data.metadata.numberOfPages) ;
      })
      .catch((error)=>{
         toast.error(error.response.data.message)
      })
   }
   



   function showCurrentPage(data){
      setCurrentPage(data?.metadata.currentPag)
      setNumberOfPages(data?.metadata.numberOfPages)
      setLimit(data?.metadata.limit)
      setBranchCount(data?.branches.length)
   }



   return (
      <>
         <BranchContext.Provider value={{
               getTypeBranch ,  
               showCurrentPage ,
               getData ,
               fetchData ,
               getSpecificBranch,
               deleteBranch,

               branch , 
               setBranch ,

               branchCount ,
               setBranchCount ,

               limit ,
               setLimit ,

               numberOfPages ,
               setNumberOfPages ,

               currentPage ,
               setCurrentPage ,

               countItem ,
               setCountItem ,

               filter ,
               setFilter ,

               branchData ,
               setBranchData ,

               branches ,
               setBranches ,

               pageCount ,

            }}>
            {props.children}
         </BranchContext.Provider>
      </>
   )
}